import { Component, EventEmitter, Output, Type, inject } from '@angular/core';
import { RequestCustomerComponent } from '../request-customer/request-customer.component';
import { BaseViewConfigService } from '../../services/base-view-config/base-view-config.service';
import { RequestAccountComponent } from '../request-account/request-account.component';

@Component({
  selector: 'lib-request-account-with-customer-tabs',
  templateUrl: './request-account-with-customer-tabs.component.html',
  styleUrls: ['./request-account-with-customer-tabs.component.scss'],
  standalone: false
})
export class RequestAccountWithCustomerTabsComponent {
  @Output()
  returnToLogin = new EventEmitter<void>();

  protected baseViewConfigService = inject(BaseViewConfigService);

  userFormComponent: Type<RequestAccountComponent> = this.getRequestAccountUserComponent();
  customerFormComponent: Type<RequestCustomerComponent> = this.getCustomerFormComponent();

  protected getRequestAccountUserComponent(): Type<RequestAccountComponent> {
    return this.baseViewConfigService.getRequestAccountUserComponent();
  }

  protected getCustomerFormComponent(): Type<RequestCustomerComponent> {
    return this.baseViewConfigService.getRequestCustomerComponent();
  }

  returnToLoginFn() {
    this.returnToLogin.emit();
  }
}
